/*FRV*/
if (window.location.pathname.includes("placement/frv")) {
    let map, polyline, origin, marker,infowindow;
    let markers = [];

    function setMapOnAll(map) {
        for (var i = 1; i < markers.length; i++) {
          markers[i].setMap(map);
        }
    }

    // Removes the markers from the map, but keeps them in the array.
    function clearMarkers() {
        setMapOnAll(null);
    }

    function addMarkerListener(marker, address) {
        google.maps.event.addListener(marker, 'click', (function(marker, address) {
            return function() {
                var html = [
                    "<div>",
                        "<a href='/placement/edit/"+app.placement.id+"'>"+app.placement.policyholder.name+"</a>",
                    "</div>",
                    "<div>",
                    address,
                    "</div>"
                ].join("");
                infowindow.setContent(html);
                let latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
                infowindow.setPosition(latlng);
                infowindow.open(map, marker);
            }
        })(marker, address));
    }

    var options = {
        'drawCallback': function(settings){
            var api = this.api();
            var properties = api.rows().data();

            if(typeof map !== 'undefined'){
                if(typeof polyline !== 'undefined')
                    polyline.setMap(null);

                clearMarkers();

                polyline = new google.maps.Polyline({
                    path: [],
                    strokeColor: '#FF0000',
                    strokeWeight: 3
                });

                polyline.setMap(map);
                var bounds = new google.maps.LatLngBounds();

                for (var i = 0;i<properties.length;i++) {
                    let destination = new google.maps.LatLng(properties[i]['latitude'], properties[i]['longitude']);
                    markers.push(new google.maps.Marker({
                        position: destination,
                        map: map,
                        icon:{
                            url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
                        }
                    }));

                    load_directions(origin, destination);
                    bounds.extend(markers[markers.length-1].position);
                    let marker = markers[markers.length-1];
                    let address = properties[i].address;
                    addMarkerListener(marker, address);
                }

                map.fitBounds(bounds);
            }
        },
        columnDefs:[
            {
                render: function(data, type, row){
                    return 0;
                },
                targets: [0]
            },
            {
                render: function(data, type, row){
                    return formatter.format(data);
                },
                targets: [2]
            },
            {
                width: "300px", targets: 1
            },
            {
                width: "50px", targets: 2
            }
        ]
    };
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    })

    $.each($(".data-table"), function(){
        $(this).data("options", options);
    });


    function load_directions(origin, destination) {
        let directionsDisplay = new google.maps.DirectionsRenderer();
        let directionsService = new google.maps.DirectionsService();

        directionsDisplay.set(map);

        let request = {
            origin: origin,
            destination: destination,
            travelMode:'DRIVING'
        };

        directionsService.route(request, function(response, status) {
            if (status == "OK") {
                directionsDisplay.setDirections(response);
                var bounds = new google.maps.LatLngBounds();
                var legs = response.routes[0].legs;

                for (i=0;i<legs.length;i++) {
                    var steps = legs[i].steps;
                    for (j=0;j<steps.length;j++) {
                        var nextSegment = steps[j].path;
                        for (k=0;k<nextSegment.length;k++) {
                            polyline.getPath().push(nextSegment[k]);
                            bounds.extend(nextSegment[k]);
                        }
                    }
                }

                map.fitBounds(bounds);
            }
        });
    }

    function load_map() {
        infowindow = new google.maps.InfoWindow();
        origin = new google.maps.LatLng(app_data.loss_address.address.latitude, app_data.loss_address.address.longitude);

        map = new google.maps.Map(document.querySelector('.property-map'), {zoom: 3, center: origin});

        marker = new google.maps.Marker({
            position: origin,
            map: map,
            icon: {
                url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
            }
        });
        marker.setVisible(true);

        let address = [
            _.get(app_data, "loss_address.address.address"),
            _.get(app_data, "loss_address.address.city"),
            _.get(app_data, "loss_address.address.state.abbr"),
            _.get(app_data, "loss_address.address.zip")
        ].join(", ");

        addMarkerListener(marker, address);

        var input = document.querySelector('form[action="/api/frv_property/create"] input[name="property[address][full_address]"]');
        var options = {
            types: ['address']
        };

        autocomplete = new google.maps.places.Autocomplete(input, options);

        autocomplete.setFields(['address_components', 'geometry']);

        var mutationObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if(mutation.attributeName === "autocomplete"){
                    $(input).attr("autocomplete", "new-password");
                    mutationObserver.disconnect();
                }
            });
        });

        mutationObserver.observe(input,{
            attributes:true
        });

        var componentForm = {
            street_number: {
                "name":'short_name',
                "value":""
            },
            route: {
                "name":'long_name',
                "value":""
            },
            locality: {
                "name":'long_name',
                "value":""
            },
            administrative_area_level_1: {
                "name":'long_name',
                "value":""
            },
            country: {
                "name":'long_name',
                "value":""
            },
            postal_code: {
                "name":'short_name',
                "value":""
            }
        };

        autocomplete.addListener('place_changed', function() {
            var place = autocomplete.getPlace();

            if (!place.geometry) {
                return;
            }

            for (var i = 0; i < place.address_components.length; i++) {
                var addressType = place.address_components[i].types[0];
                if (componentForm[addressType]){
                    var val = place.address_components[i][componentForm[addressType]["name"]];
                    componentForm[addressType]["value"] = val;
                }
            }
            let display = $(input).closest('form');

            var state = display.find("[name='property[address][state_id]'] option").filter(function(){return $(this).text()==componentForm['administrative_area_level_1']['value'];}).val();

            display.find("[name='property[address][address]']").val(componentForm['street_number']['value'] + " " + componentForm['route']['value']);
            display.find("[name='property[address][city]']").val(componentForm['locality']['value']);
            display.find("[name='property[address][state_id]']").val(state).trigger("change");
            display.find("[name='property[address][zip]']").val(componentForm['postal_code']['value']);

            var destination = place.geometry.location;

            display.find("[name='property[address][latitude]']").val(destination.lat()).trigger("change");
            display.find("[name='property[address][longitude]']").val(destination.lng());

            var service = new google.maps.DistanceMatrixService();
            service.getDistanceMatrix(
                {
                    origins: [origin],
                    destinations: [destination],
                    travelMode:'DRIVING',
                    unitSystem:google.maps.UnitSystem.IMPERIAL
                }, function(response, status) {

                if (status!=='OK') return;

                if (identify(response).rows[0].elements[0].distance(false) != false) {
                    var distance = response['rows'][0]['elements'][0]['distance'];
                    var value = distance.value * 0.000621371192;
                    display.find("input[name='property[distance]']").val(parseFloat(value).toFixed(2));
                }else{
                    var distance = parseFloat(getDistance(origin, destination));
                    display.find("input[name='property[distance]']").val(distance.toFixed(2));
                }
              });
      });
    }

    $(document).ready(function(){
        if (typeof window.maps_loaded !== 'undefined') {
            load_map();
        } else {
            window.initMap = load_map;
        }
    });

    $(window).on("dataTableInit.limelight", function(e, t) {
        t.on("draw", function(){
            update_analysis();
        });

        update_analysis();
        $(".dataTables_wrapper").on('click', '.datatable-command', function(){
            var type = $(this).data("type");
            var table = $(this).closest(".data-table");

            switch (type) {
                case "pdf":
                    app.active_property_id = $(this).data("id");
                    popup_open("frv_file_manager");
                    break;
                default:
                    break;
            }
        });

        t.on('order.dt search.dt', function () {
            t.column(0, {search:'applied', order:'applied'}).nodes().each( function (cell, i) {
                cell.innerHTML = i+1;
            });
        }).draw();
    });

    function update_analysis() {
        var property_data = $(".data-table").DataTable().data();
        var value = 0;
        var range = [];

        $.each(property_data, function() {
            var val = isNaN(parseFloat(this.rent)) ? 0.00 : parseFloat(this.rent).toFixed(2);
            range.push(val);
            value += val;
        });

        window.app_data.frv_rent_low = Math.min.apply(null, range);
        window.app_data.frv_rent_high = Math.max.apply(null, range);
    }

    $(window).on("form-success", function (e, response) {
        if (typeof response['dataTable'] !== 'undefined') {
            const data = response.dataTable.data[0]
            switch (response['method']) {
                case "create":
                    window.app_data.placement.frv_properties.push(data);
                    break;
                case "update":
                    const index = window.app_data.placement.frv_properties.findIndex((frv) => frv.id == data.id);
                    window.app_data.placement.frv_properties[index] = data;
                    break;
                default:
                    break;
            }
        }
    });

    $(window).on("confirm.bs.popover", function(e, popover, confirm){
        const el = $(popover.element);
        const id = el.data("id");
        if(confirm && el.hasClass("datatable-command") && id) {
            window.app_data.placement.frv_properties = window.app_data.placement.frv_properties.filter((frv) => frv.id != id)
        }
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/frv.js